import React, {useState} from "react";
import * as palette from "../Variables";
import styled from "styled-components";

const StyledWorkRecommendation = styled.div`

    a {
        font-weight: 400;
        transition: color 250ms ease;
        text-decoration: none;
        text-decoration-style: solid;
        text-underline-offset: 6px;
        color: ${palette.neutral8};
        display: block;

        &:hover {

            color: ${palette.pinkMain};

            .h4 {
                color: ${palette.pinkMain};
            }

            img {
                scale: 1.05;
            }
        }

        .h4 {
            transition: all 250ms ease;
            display: inline;
            text-decoration: underline;
            text-decoration-color: ${palette.neutral8};
        }
    }

    div.img-container {
        width: 100%;
        aspect-ratio: 3/2;
        overflow: hidden;
        border-radius: 8px;
        margin-bottom: 16px;

        @media (min-width: 576px) {
            max-width: 100%;
        }

        @media (min-width: 768px) {
            margin-bottom: 16px;
        }

        img {
            width: 100%;
            aspect-ratio: 3/2;
            object-fit: cover;
            transition: all 350ms ease;
        }
    }

    .small.italic {
        color: ${palette.neutral9};
        margin-top: 6px;
        margin-bottom: 8px;

        @media (min-width: 768px) {
            margin-bottom: 0px;
        }
    }
`;

const WorkRecommendation = ({src, alt, title, description, href}) => {
    return(
        <StyledWorkRecommendation>
            <a href={href}>
                <div className={"img-container"}>
                    <img src={src} alt={alt}/>
                </div>
                <div>
                    <p className={"h4"}>{title}</p>
                </div>
                <p className={"small italic"}>{description}</p>
            </a>
        </StyledWorkRecommendation>
    )
}

export default WorkRecommendation;